var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 10,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3A3A",
    d: "M10.39 8.64H.985V.11A.11.11 0 0 0 .875 0H.109A.11.11 0 0 0 0 .11v9.406c0 .06.05.109.11.109h10.28c.06 0 .11-.05.11-.11V8.75a.11.11 0 0 0-.11-.11ZM2.188 7.548h.766c.06 0 .11-.05.11-.11V5.47a.11.11 0 0 0-.11-.11h-.765a.11.11 0 0 0-.11.11v1.968c0 .06.05.11.11.11Zm2.079 0h.765c.06 0 .11-.05.11-.11V3.063a.11.11 0 0 0-.11-.109h-.765a.11.11 0 0 0-.11.11v4.374c0 .06.05.11.11.11Zm2.078 0h.765c.06 0 .11-.05.11-.11V4.13a.11.11 0 0 0-.11-.11h-.765a.11.11 0 0 0-.11.11v3.309c0 .06.05.109.11.109Zm2.078 0h.765c.06 0 .11-.05.11-.11V1.97a.11.11 0 0 0-.11-.11h-.765a.11.11 0 0 0-.11.11v5.468c0 .06.05.11.11.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/Graph.f868a6166a996a53cbd699891a1b3c86.svg";
export { ForwardRef as ReactComponent };